import React, { useState } from "react";
import { Link } from "react-router-dom";

const NavMenu = () => {
  const [istoggled, setToggle] = useState(false);
  const Toggle = () => {
    setToggle(!istoggled);
    if (!istoggled) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
  };
  return (
    <div className="nav__menu ">
      <div
        onClick={Toggle}
        className={istoggled ? "hamburger active" : "hamburger"}
      >
        <div className="hamBox">
          <div className="hamBox__inner"></div>
        </div>
      </div>

      <aside className={istoggled ? "menu__sidebar active" : "menu__sidebar"}>
        <nav>
          <ol>
            <li>
              {/* <a href="#About">About</a> */}
              <Link to="/about">About</Link>
            </li>
            <li>
              <a href="#Skills">Skills</a>
            </li>
            <li>
              <a href="#Project">Projects</a>
            </li>
            <li>
              <a href="#Contact">Contact</a>
            </li>
            <li>
              {/* <a href="/blog">Blog</a> */}
              <Link to="/blog">Blog</Link>
            </li>
          </ol>
          <button className="resume__button">
            <a href="https://drive.google.com/file/d/1uklG_5qf_7ip5n5G1dYVhwAauHjUxtVJ/view">
              Resume
            </a>
          </button>
        </nav>
      </aside>
    </div>
  );
};

export default NavMenu;
